import {
  WhatsappShareButton,
  TelegramShareButton,
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share";

import {
  EmailIcon,
  FacebookIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

const SocialShareIcons = ({ title, caption, url }) => {
  return (
    <>
      <WhatsappShareButton title={title} url={url}>
        <WhatsappIcon size={30} round />
      </WhatsappShareButton>
      <TelegramShareButton title={title} url={url}>
        <TelegramIcon size={30} round />
      </TelegramShareButton>
      <FacebookShareButton quote={title} url={url}>
        <FacebookIcon size={30} round />
      </FacebookShareButton>
      <TwitterShareButton title={title} url={url}>
        <TwitterIcon size={30} round />
      </TwitterShareButton>
      <EmailShareButton subject={title} body={caption} url={url}>
        <EmailIcon size={30} round />
      </EmailShareButton>
    </>
  );
};

export default SocialShareIcons;
